export default {
    /* GET_DIE_CUTTERS
    ---------------------------------------------------------------
    */
    GET_DIE_CUTTERS_REQUEST: (state) => {
        state.dieCuttersLoading = true
    },
    GET_DIE_CUTTERS_SUCCESS: (state, data) => {
        state.dieCutters = data
        state.dieCuttersLoading = false
    },
    GET_DIE_CUTTERS_FAILURE: (state) => {
        state.dieCuttersLoading = false
    },
    GET_DIE_CUTTERS_OWNERSHIP_TYPES_SUCCESS: (state, data) => {
        state.ownershipTypes = data
    },
    SET_DIE_CUTTERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_DIE_CUTTERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
    SET_CANCEL_TOKEN: (state, token) => {
        state.cancelToken = token
    }
}